/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import styled from "styled-components";

const Dimmed = styled.div.attrs(({ $active }) => ({ inert: $active ? "" : undefined, "aria-busy": $active || undefined }))`
  transition: opacity 0.2s ease;
  ${({ $active }) => $active && "opacity: 0.5; transition-delay: 0.15s;"}
`;

export default Dimmed;
